export default "__VITE_ASSET__zad8NBrV__"